import React, { useState } from 'react';
import { ChevronDown, ChevronUp, User, Users } from 'lucide-react';

const Contacts = ({ contactsData, onContactSelect, currentUserId }) => {
  const [expandedClass, setExpandedClass] = useState(null);

  const toggleExpand = (classId) => {
    setExpandedClass(expandedClass === classId ? null : classId);
  };

  const handleContactClick = (contact) => {
    onContactSelect(contact);
  };

  return (
    <div className="space-y-4">
      {contactsData.map((classData, idx) => {
        const classId = `${classData.classValue}-${classData.section}`;
        const isExpanded = expandedClass === classId;

        // Filter out the current user from the teacher and students
        const showTeacher = classData.teacherId !== currentUserId;
        const filteredStudents = classData.enrolledStudent.filter(student => student.studentId !== currentUserId);

        if (!showTeacher && filteredStudents.length === 0) {
          return null; // Don't render this class if there are no contacts to show
        }

        return (
          <div key={idx} className="border rounded-lg overflow-hidden">
            <button
              className="w-full flex justify-between items-center p-4 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => toggleExpand(classId)}
            >
              <span className="font-semibold">
                Class {classData.classValue} - Section {classData.section}
              </span>
              {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {isExpanded && (
              <div className="p-4 bg-gray-50">
                {showTeacher && (
                  <>
                    <h3 className="font-bold text-lg mb-2 flex items-center"><User className="mr-2" /> Teacher</h3>
                    <div 
                      className="flex items-center space-x-3 mb-4 bg-blue-50 p-2 rounded-lg cursor-pointer hover:bg-blue-100"
                      onClick={() => handleContactClick({ id: classData.teacherId, name: classData.teacherName, type: 'teacher' })}
                    >
                      <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
                        <User className="w-6 h-6 text-white" />
                      </div>
                      <span>{classData.teacherName}</span>
                    </div>
                  </>
                )}
                {filteredStudents.length > 0 && (
                  <>
                    <h3 className="font-bold text-lg mb-2 flex items-center"><Users className="mr-2" /> Students</h3>
                    <ul className="space-y-2">
                      {filteredStudents.map((student) => (
                        <li 
                          key={student.studentId} 
                          className="flex items-center space-x-3 bg-gray-50 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
                          onClick={() => handleContactClick({ id: student.studentId, name: student.studentName, type: 'student' })}
                        >
                          <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                            <User className="w-6 h-6 text-gray-600" />
                          </div>
                          <span>{student.studentName}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Contacts;

